import React from 'react'
import clsx from 'clsx'

import { Add } from 'iconsax-react'
import TableSettings from '../TableSettings'

import useCombinedTableState from '@SonarCX/hooks/useCombinedTableState'
import { useBreakpoint } from '@SonarCX/providers/BreakpointProvider'
import useBaseStyles from '../TaskHeader/styles'
import useStyles from './styles'

const NoCategoryTaskHeader = ({ canAdd, createTask }) => {
  const { name, key } = useCombinedTableState()
  const { isSmall } = useBreakpoint()

  const [hovering, setHovering] = React.useState(false)

  const baseClasses = useBaseStyles()
  const classes = useStyles()

  return (
    <div
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      className={classes.root}
      data-testid={`${name}-task-header`}
    >
      <div className={classes.header}>No Category</div>

      {hovering && canAdd && createTask && (
        <div className={clsx(baseClasses.add, classes.add)}>
          <div
            onClick={createTask}
            className={baseClasses.addButton}
            data-testid={`${name}-task-header-button`}
          >
            <Add className='icon' /> Task
          </div>
        </div>
      )}

      {hovering && !isSmall && <TableSettings id={key} />}
    </div>
  )
}

export default NoCategoryTaskHeader
